<mat-expansion-panel #panel (opened)="afterPanelExpand()" (closed)="afterPanelCollapsed()">
	
	<mat-expansion-panel-header [expandedHeight]="'61px'" [collapsedHeight]="'61px'">
		<mat-panel-title>
			<div class="title-main" [class.title-editable]="titleEditable"
			(mouseup)="onTitleMouseEvent($event)"
			(click)="onTitleMouseEvent($event)"
			(mousedown)="onTitleMouseEvent($event)">
				<div
				(mousedown)="onTitleClick($event, editTitleInput)" [hidden]="editTitle">
					{{propertyKey}}
				</div>
				<div [hidden]="!editTitle">
					<input
						#editTitleInput
						type="text"
						[(ngModel)]="propertyKey"
						(change)="onMessageTitleChange($event)"
						(keydown.enter)="onMessageTitleEnter($event)"
						name="editMessageSelector"
					/>
				</div>
			</div>
			<div class="title-sub" [class.multiple]="numProcedures > 0">{{numProcedures}} procedures</div>
		</mat-panel-title>
	</mat-expansion-panel-header>

	<!-- <button (click)="addProcedure()">add procedure (test)</button> -->
	<div class="procedure-list"
		cdkDropList
		[cdkDropListData]="procedures"
		(cdkDropListDropped)="procedureDropped($event)">
		
		<procedure
			*ngFor="let procedure of procedures; let i = index; trackBy: procedureTrackBy.bind(this);"
			[handlerName]="propertyKey"
			[procedure]="procedure"
			[stateTrackingUid]="stateTrackingUid + '_p' + i"
			(procedureChanged)="procedureChanged($event)"
			(delete)="removeProcedure($event)"
			(contextmenu)="onProcedureContextMenu($event, procedure)"
			cdkDrag
			>
			<!-- <div *ngIf="procedure.condition.variables.length !== 0" class="procedure-handle" cdkDragHandle></div> -->
			<div *ngIf="procedure?.type === 'conditional'" class="procedure-buttons">
				<div class="action-icon-button" (click)="removeProcedure(procedure)">
					<i class="fa fa-trash"></i>
				</div>
				<div class="procedure-handle drag-handle-bars action-icon-button" cdkDragHandle>
					<i class="fa fa-bars"></i>
				</div>
			</div>
		</procedure>
	</div>
	<add-procedure (onChange)="actionAdded($event)" [propertyKey]="propertyKey" [procedures]="procedures" [allowIfElse]="true"></add-procedure>
</mat-expansion-panel>
